import BackendService from './BackendService';

export default class SourceMappingService {
  static getSourceMapping(dealerId) {
    const params = { dealerId };
    return BackendService.get(`/sourceMappings/${dealerId}`, { params });
  }

  static createSourceMapping(sourceMapping) {
    return BackendService.post('/sourceMappings', {
      body: sourceMapping,
    });
  }

  static updateSourceMapping(sourceMapping) {
    return BackendService.put(`/sourceMappings/${sourceMapping.id}`, {
      body: sourceMapping,
    });
  }
}
